import { Drawer } from "antd";
import { Observer } from 'mobx-react';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LimitationModal } from '../../../../common/components/LimitationModal/LimitationModal';
import { ROUTES } from '../../../../common/constants/routes.const';
import { navigateToUrl } from '../../../../common/utils/navigation.utils';
import { NewCreateItemModal } from '../../../add-item/components/NewCreateItemModal';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
import { useStore } from "../../../app/data/root.store";
import { CreateMenu } from "../Header/Header";
import { ReportsIcon, InsightsIcon } from '../Sidebar/icons/sidebar-icons';
import { AddButtonWrapper, FooterWrapper, MenuButtonText, MenuButtonWrapper, MenuLinkButtonWrapper } from "./MobileFooter.styles";
import CreateFromFilesDrawer from "../../../../common/components/drawers/CreateFromFilesDrawer";

export function MobileFooter(props) {
    const {isHidden} = props;
    const history = useHistory();
    const location = useLocation();
    const { uiStore , createItemStore , userStore,filtersStore, billingStore, wealthStore, assistanceStore } = useStore();

    const { trackEvent } = useAnalytics();

    const [isCreateMenuOpen, setIsCreateMenuOpen] = useState(false);
    const [showCreateFromFilesDrawer, setShowCreateFromFilesDrawer] = useState(false);

    const handleMenuItemClick = (destination) => {
      trackEvent('CTA Clicked', {
        destination,
        location: 'Mobile footer menu',
        cta_text: destination,
        type: 'Button',
        url: window.location.href
      })
    }
  

    const handlePortfolioClick = () => {
        filtersStore.handleClearFilterSelections();
        filtersStore.closeAllParameters();
        wealthStore.setViewType('overview');
        if (location.pathname.includes(ROUTES.wealth.url)) {
          wealthStore.refreshWealthData();
        }
        // uiStore.setIsRightMenuOpen(!uiStore.isRightMenuOpen)
      }

    const onCreateSyncClick = (syncMode) => {
        createItemStore.setInstitutionStep(syncMode);
        createItemStore.setShowModal(true);
        setIsCreateMenuOpen(false);
      }
    
      const onCreateManuallyClick = () => {
        createItemStore.setCategoryStep(true);
        createItemStore.setShowModal(true);
        setIsCreateMenuOpen(false);
      }

      const onVaultClick = () => {
        setShowCreateFromFilesDrawer(true);
        setIsCreateMenuOpen(false);
      }
    
      const onMagicBoxClick = () => {
        navigateToUrl(history, ROUTES.magicBox.url);
        setIsCreateMenuOpen(false);
      }
    
      const handleItemAdded = () => {
        createItemStore.setShowModal(false);
        userStore.updateData();
      }
    
      const handleCreateItemModalClose = () => {
        createItemStore.setIsPlaidInProcess(false);
        createItemStore.setIsSaltedgeInProcess(false);
        createItemStore.setShowModal(false);
      }

      return <Observer>{() => (
        <FooterWrapper isHidden={isHidden} id="mobile_footer">
            <MenuLinkButtonWrapper to={ROUTES.wealthOverview.url} activeStyle={{ opacity : uiStore.isAppMobileMenuOpen ? 0.5 : 1 }} onClick={()=>{handleMenuItemClick('my portfolio');uiStore.setIsAppMobileMenuOpen(false);handlePortfolioClick()}} >
                <HomeIcon />
                <MenuButtonText>Portfolio</MenuButtonText>
            </MenuLinkButtonWrapper>
            {assistanceStore.showAssistance &&
            <MenuLinkButtonWrapper to={ROUTES.assistance.url} activeStyle={{ opacity: uiStore.isAppMobileMenuOpen ? 0.5 : 1 }} onClick={() => { handleMenuItemClick('insights ai') }}>
              <InsightsIcon style={{width: '24px', height: '24px'}} />
              <MenuButtonText>Insights</MenuButtonText>
            </MenuLinkButtonWrapper>}
            <AddButtonWrapper onClick={()=>{handleMenuItemClick('Add item');setIsCreateMenuOpen(true)}}>
                    <AddIcon />
            </AddButtonWrapper>
            <MenuLinkButtonWrapper to={ROUTES.reports.url}  activeStyle={{ opacity : uiStore.isAppMobileMenuOpen ? 0.5 : 1 }} onClick={()=>{handleMenuItemClick('reports')}}>
                    <ReportsIcon />
                    <MenuButtonText>Reports</MenuButtonText>
            </MenuLinkButtonWrapper>
            <MenuButtonWrapper isSelected={uiStore.isAppMobileMenuOpen} onClick={()=>{handleMenuItemClick('More menu');uiStore.setIsAppMobileMenuOpen(!uiStore.isAppMobileMenuOpen)}}>
                    <MoreIcon />
                    <MenuButtonText>More</MenuButtonText>
            </MenuButtonWrapper>

            <Drawer
                closable={false}
                visible={isCreateMenuOpen }
                width={ '100%' }
                height={'auto'}
                className={'addItemDrawerContainer_mobile'}
                placement={'bottom'}
                onClose={()=>{setIsCreateMenuOpen(false)}}>
                <CreateMenu fullWidth 
                onSyncClick={onCreateSyncClick}
                onManuallyClick={onCreateManuallyClick}
                onMagicClick={onMagicBoxClick}
                onVaultClick={onVaultClick}
                userStore={userStore}
                isMobileMenu
                onClose={()=>{setIsCreateMenuOpen(false)}}
                setMenuVisibility={setIsCreateMenuOpen} />
            </Drawer>

            {createItemStore.showModal &&
                <NewCreateItemModal
                    onAddItem={() => { handleItemAdded() }}
                    onClose={handleCreateItemModalClose}
            />}

{ createItemStore.isShowAddManualItemLimitModal && <LimitationModal modalType="addItems" 
        paramsForText={[userStore.userLimitations.manualActiveItems.manualItems]}
        onUpgrade={()=>{billingStore.setShowPricingTableModal(true)}}
        onClose={()=>createItemStore.setShowAddManualItemLimitModal(false) } />}

        { createItemStore.isShowAddSyncLimitModal && <LimitationModal modalType="instSync" 
        paramsForText={[userStore.userLimitations.financialInstitutionSync.syncedInstitutions]}
        onUpgrade={()=>{billingStore.setShowPricingTableModal(true)}}
        onClose={()=>createItemStore.setShowAddSyncLimitModal(false) } />}

        { createItemStore.isShowAddVipSyncLimitModal && <LimitationModal modalType="vipSync" 
        paramsForText={[userStore.userLimitations.financialInstitutionSync.syncedInstitutions]}
        onUpgrade={()=>{billingStore.setShowPricingTableModal(true)}}
        onClose={()=>createItemStore.setShowAddVipSyncLimitModal(false) } />}

      <CreateFromFilesDrawer
        open={showCreateFromFilesDrawer}
        onClose={() => setShowCreateFromFilesDrawer(false)}
        onUploadClick={() => {
          setShowCreateFromFilesDrawer(false);
          setIsCreateMenuOpen(false);
        }}
      />
        </FooterWrapper>
    )}</Observer>
}


const HomeIcon = ({isActive,className}) => {
    return (<svg className={className} width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.9 20.5V10.2562C20.9 9.76069 20.6553 9.29711 20.2461 9.0176L14.0281 4.7705C13.3478 4.30585 12.4522 4.30585 11.772 4.7705L5.55399 9.0176C5.14478 9.29711 4.90002 9.76069 4.90002 10.2562V20.5C4.90002 20.7761 5.12388 21 5.40002 21H10C10.2762 21 10.5 20.7761 10.5 20.5V17.1676C10.5 16.6153 10.9477 16.1676 11.5 16.1676H14.3C14.8523 16.1676 15.3 16.6153 15.3 17.1676V20.5C15.3 20.7761 15.5239 21 15.8 21H20.4C20.6762 21 20.9 20.7761 20.9 20.5Z" stroke="#EAF0F1" strokeWidth="1.5" fill={isActive ? '#EAF0F1' : 'none'}/>
    </svg>
    )
}



const AddIcon = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.59998 14L8.59998 2" stroke="#EAF0F1" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
<path d="M14.6 8H2.59998" stroke="#EAF0F1" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
</svg>

)

const MoreIcon = () => {
    return (<svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="4.06531" y1="7.25" x2="20.7459" y2="7.25" stroke="#EAF0F1" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="4.06531" y1="13.75" x2="20.7459" y2="13.75" stroke="#EAF0F1" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="4.06531" y1="20.25" x2="20.7459" y2="20.25" stroke="#EAF0F1" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
    )
}
